import React from 'react';
import { ArrowRight } from 'lucide-react';

export const FinalCTASection = () => (
  <section className="py-20 border-t border-[var(--border-medium)] bg-[var(--bg-card)]/50 relative overflow-hidden">
    <div className="container mx-auto px-6 text-center relative z-10">
      <h2 className="heading-2 mb-8">Ready to grow?</h2>
      <p className="text-xl text-[var(--text-secondary)] mb-10 max-w-2xl mx-auto">
        See exactly how to improve your site performance and conversion with a professional audit.
      </p>
      <a
        href="mailto:digitalleaderproject@gmail.com?subject=Free%20Website%20Audit%20Request"
        className="btn-primary inline-flex"
        data-testid="footer-audit-cta"
      >
        Get a free website audit <ArrowRight className="ml-2 w-5 h-5" />
      </a>
    </div>
  </section>
);
